<app-admin-list-page [title]="'Tools' | translate">

  <button slot="actions" class="btn btn-primary" (click)="clearCache()">
    {{ 'Clear cache' | translate }}
  </button>

</app-admin-list-page>
